import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CompleteInfoButton.module.css';

const CompleteInfoButton = ({
  isCompleted = false,
  isDisabled = false,
  noPendingAction = false,
  onClick,
}) => {
  const { t } = useTranslation('petDemos');

  if (noPendingAction) {
    return null;
  }

  if (isCompleted) {
    return (
      <button
        className={styles.editInformationButton}
        onClick={onClick}
        type="button"
      >
        {t('policyInformation.editInformation')}
      </button>
    );
  }

  return (
    <button
      className={isDisabled
        ? styles.completeInfoButtonDisabled
        : styles.completeInfoButton}
      disabled={isDisabled}
      onClick={onClick}
      type="button"
    >
      {t('policyInformation.completeInformation')}
    </button>
  );
};

export { CompleteInfoButton };
